// Locale-aware formatting. German/Spanish use comma decimals.
const LOCALE_MAP = { en: "en-GB", de: "de-DE", es: "es-ES" };

export function locale(lang) {
  return LOCALE_MAP[lang] || "en-GB";
}

export function fmtNumber(value, lang, decimals = 2) {
  return new Intl.NumberFormat(locale(lang), {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value);
}

// signed number e.g. +0.81 / -0.34 (Mode B credit)
export function fmtSigned(value, lang, decimals = 2) {
  const s = fmtNumber(Math.abs(value), lang, decimals);
  const sign = value >= 0 ? "+" : "−";
  return `${sign}${s}`;
}

export function fmtTime(iso, lang) {
  return new Intl.DateTimeFormat(locale(lang), {
    hour: "2-digit", minute: "2-digit",
  }).format(new Date(iso));
}

export function fmtDate(iso, lang) {
  return new Intl.DateTimeFormat(locale(lang), {
    weekday: "short", day: "numeric", month: "short",
  }).format(new Date(iso));
}

// Format a score value using the active scoring mode display rules
import { scoreMeta } from "./scoring";
export function fmtScore(mode, value, lang) {
  const meta = scoreMeta(mode);
  return meta.betterIsLower ? fmtNumber(value, lang, 2) : fmtSigned(value, lang, 2);
}
